import React, { useEffect, useState } from "react";
import NavHeader from "../components/NavHeader";
import {
  Badge,
  Button,
  HStack,
  Icon,
  Image,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  Text,
  Tooltip,
  VStack,
} from "@chakra-ui/react";
import cr from "../lib/request";
import NoData from "../components/NoData";
import ComponentSpinner from "../components/ComponentSpinner";
import { Course } from "../const/types";
import {
  ArrowRight,
  Clock,
  MagnifyingGlass,
  UsersThree,
} from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { iconSize } from "../const/sizes";
import formatDate from "../lib/formatDate";
import formatNumberShort from "../lib/formatNumberShort";
import formatNumber from "../lib/formatNumber";
import TambahCourseModal from "../components/courseComponents/TambahCourseModal";
import useTrigger from "../globalState/useTrigger";
import formatDuration from "../lib/formatDuration";

export default function BlogPost() {
  const [data, setData] = useState<Course[] | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const { trigger } = useTrigger();

  useEffect(() => {
    setLoading(true);
    const url = `api/course/allcourse`;
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [trigger]);

  return (
    <>
      <NavHeader backLink={"/course"} label={"Course List"} />

      <HStack justify={"space-between"} p={5}>
        <InputGroup>
          <InputLeftElement>
            <Icon as={MagnifyingGlass} />
          </InputLeftElement>
          <Input
            maxW={"400px"}
            placeholder="Pencarian"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </InputGroup>

        <TambahCourseModal />

        <Button
          colorScheme="ap"
          variant={"outline"}
          as={Link}
          to={"/course/restore"}
          rightIcon={<Icon as={ArrowRight} fontSize={iconSize} />}
          flexShrink={0}
        >
          Restore
        </Button>
      </HStack>

      {!loading && data && data.length > 0 ? (
        <VStack align={"stretch"} px={3} pb={5}>
          <SimpleGrid columns={[1, null, 2, 3, 4, 5]} gap={4}>
            {data.map((course, i) => {
              const ok =
                course.nama_course
                  .toLowerCase()
                  .includes(search.toLowerCase()) ||
                course.description
                  .toLowerCase()
                  .includes(search.toLowerCase()) ||
                course.theme.theme_name
                  .toLowerCase()
                  .includes(search.toLowerCase()) ||
                course.id.toString().includes(search);

              return (
                ok && (
                  <VStack
                    key={i}
                    align={"stretch"}
                    as={Link}
                    to={`/course/${course.id}/edit`}
                    borderRadius={12}
                    p={2}
                    transition={"200ms"}
                    cursor={"pointer"}
                    _hover={{
                      boxShadow: "0 0 0 1px var(--divider2))",
                      bg: "var(--divider)",
                      // border: "1px solid var(--divider3)",
                    }}
                    className="clicky"
                    gap={0}
                  >
                    <Image
                      src={`${process.env.REACT_APP_MEDIA_BASE_URL}${course.image}`}
                      objectFit={"cover"}
                      aspectRatio={"16/9"}
                      mb={3}
                    />

                    <VStack p={2} align={"stretch"} flex={1} gap={0}>
                      <Text
                        fontSize={[20, null, 22]}
                        fontWeight={700}
                        noOfLines={2}
                        mb={4}
                        lineHeight={1.4}
                      >
                        {course.nama_course}
                      </Text>

                      <HStack
                        justify={"space-between"}
                        mt={"auto"}
                        align={"flex-end"}
                        mb={4}
                      >
                        <HStack opacity={0.5}>
                          <Icon as={Clock} />
                          <Text>{`${formatDuration(
                            course.total_duration
                          )}`}</Text>
                        </HStack>

                        <Tooltip
                          label={`${formatNumber(
                            course.totalmembers
                          )} mengukuti`}
                        >
                          <HStack opacity={0.5}>
                            <Icon as={UsersThree} fontSize={20} />

                            <Text noOfLines={1}>
                              {formatNumberShort(course.totalmembers)}
                            </Text>
                          </HStack>
                        </Tooltip>
                      </HStack>

                      <HStack
                        align={"flex-end"}
                        justify={"space-between"}
                        gap={2}
                      >
                        <Badge
                          colorScheme={course.online_status ? "green" : "red"}
                        >
                          {course.online_status ? "Online" : "Offline"}
                        </Badge>

                        <VStack gap={0} align={"flex-end"}>
                          <Text fontSize={"small"} opacity={0.5}>
                            Terakhir diperbarui
                          </Text>
                          <Text>{`${formatDate(course.updated_at)}`}</Text>
                        </VStack>
                      </HStack>

                      {/* <Text color={"p.500"}>Klik untuk kelola</Text> */}
                    </VStack>
                  </VStack>
                )
              );
            })}
          </SimpleGrid>
        </VStack>
      ) : !loading && data && data.length === 0 ? (
        <NoData />
      ) : (
        <ComponentSpinner flex={1} />
      )}
    </>
  );
}
